import { styled } from '@compiled/react';
import styled2 from 'styled-components';
import { Flipper } from '../../utils/flip-toolkit';
import type { FlipperProps } from 'flip-toolkit/lib/types';

interface ConversationFlipperStyleProps {
    startFromTop: boolean;
}

type ConversationFlipperProps = ConversationFlipperStyleProps & FlipperProps;

// eslint-disable-next-line rulesdir/no-styled-export
export const ConversationWrapper = styled.div({
    width: '100%',
    flex: '1 1 auto',
});

/* Suppressing existing violations */
/* stylelint-disable scale-unlimited/declaration-strict-value, function-parentheses-newline-inside   */
// eslint-disable-next-line rulesdir/no-styled-export
export const ConversationFlipper = styled2<ConversationFlipperProps>(Flipper)`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: ${({ startFromTop }) => (startFromTop ? 'flex-start' : 'flex-end')};
`;
